import R from 'ramda';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import ContractBlock from '../ContractBlock';
import AgreementTextWorkForHire from './AgreementTextWorkForHire';
import AgreementTextPremiumSplit from './AgreementTextPremiumSplit';
import AgreementTextProducer from './AgreementTextProducer';
import Sidebar from '../Create/Sidebar';
import ShortContentLess from '../ContractBlock/ShortContentLess';
import { AnimationArrow } from '../AnimationArrow';

import {
  getWorkTypeNameById,
  getMemberByUserId,
  getOwnershipTypeName,
} from '../../utils';

import IconAlert from '../../assets/dealroom-icons/alert.svg';
import IconAlertGray from '../../assets/dealroom-icons/alert-gray.svg';
import IconSummary from '../../assets/dealroom-icons/summary.svg';
import IconSummaryGray from '../../assets/dealroom-icons/summary-gray.svg';

// TODO: kill off all < and > tab things
class AgreementTerms extends Component {
  tabWidth = 230;

  constructor() {
    super();
    this.state = {
      blocks: [],
      tabs: [],
      tabCount: 0,
      tabIndex: 0,
      tabName: '',
      blockIndex: 0,
      start: 0,
      previewIndex: 0,
      isCollapsPreview: false,
    };
  }

  componentWillMount() {
    const { team, agreement } = this.props;

    if (team) {
      this.props.loadMembers(team.id);
    }

    if (agreement && agreement.id) {
      this.props.loadBlockContents(agreement.id);
      this.props.loadMembers(agreement.team);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { tabName } = this.state;
    const { status, router, agreement, contractBlocks } = nextProps;

    if (this.props.status === actionTypes.AGREEMENT_UPDATE_REQUEST) {
      if (status === actionTypes.AGREEMENT_UPDATE_SUCCESS) {
        router.push('/');
      } else if (status === actionTypes.AGREEMENT_UPDATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong and we were unable to save this Agreement. Please try again. If this error persists, please contact us.'
        );
      }
    } else if (contractBlocks && this.state.tabCount === 0) {
      const wrapper = findDOMNode(this.refs.tabsContainer);
      const blocks = this.filter(agreement, contractBlocks);
      const tabCount = Math.floor((wrapper.clientWidth - 100) / this.tabWidth);
      const tabs = blocks.slice(0, tabCount);

      if (tabCount < blocks.length) {
        tabs.push('>');
      }

      this.setState(
        { blocks, tabs, tabCount, start: 0, tabName: tabs[0].name },
        () => {
          this.scrollToRef(tabs[0].name);
        }
      );
    } else if (contractBlocks && this.state.tabCount) {
      const blocks = this.filter(agreement, contractBlocks);
      const tabs = this.state.tabs.map((tab, i) => {
        if (tab === '<' || tab === '>') {
          return tab;
        } else {
          return R.find(R.propEq('id', tab.id))(blocks);
        }
      });

      this.setState({ blocks, tabs }, () => {
        this.scrollToRef(tabName);
      });
    }
  }

  filter(agreement, contractBlocks) {
    const blocks = R.filter(
      (block) =>
        (agreement.type === 'premium' &&
          block['block_type'].includes('premium') === true) ||
        (agreement.type === 'workforhire' &&
          block['block_type'].includes('work_for_hire') === true) ||
        (agreement.type === 'producer' &&
          block['block_type'].includes('producer') === true),
      contractBlocks
    );

    R.sortBy(R.prop('id'))(blocks);
    return blocks;
  }

  handleNext() {
    const { contractBlocks, agreement, agreementContractBlocks } = this.props;
    const blocks = this.filter(agreement, contractBlocks);

    let checkedAll = blocks.every(
      (block) => this.getBlockChecked(block) === true
    );

    let uncheckedBlocks = [];
    blocks.forEach((block) => {
      if (this.getBlockChecked(block) === false) {
        uncheckedBlocks = [...uncheckedBlocks, block.name];
      }
    });

    this.props.hideAlert();

    if (checkedAll) {
      const newBlocks = blocks.map((block) => {
        let id = null;
        if (agreementContractBlocks) {
          const agreementBlock = R.find(R.propEq('contract_block', block.id))(
            agreementContractBlocks
          );
          id = agreementBlock ? agreementBlock.id : null;
        }
        return {
          id,
          contract_block: block.id,
          content: block.content,
          options: JSON.stringify(block.options),
        };
      });
      this.props.saveContractBlocks(newBlocks);
      this.props.router.push('/create/review/agreement-terms');
    } else {
      this.props.alert(
        'error',
        `Oops! You did not fully answer a question. Please recheck the "${uncheckedBlocks.join(
          ', '
        )}" ${
          uncheckedBlocks.length > 1 ? 'tabs' : 'tab'
        } to see what was missed.`
      );
    }
  }

  scrollToRef = (blockName) => {
    this.refPreview.scrollTo(0, 0);
    this.refAgreementTextPreview.scrollTo(0, 0);
    let offset = 0;

    if (this.state.previewIndex === 0) {
      if (this[`ref${blockName.replace(/\s/g, '')}`]) {
        offset =
          findDOMNode(
            this[`ref${blockName.replace(/\s/g, '')}`]
          ).getBoundingClientRect().top -
          findDOMNode(this.refPreview).getBoundingClientRect().top -
          50;
      }
    }
    this.refPreview.scrollTo(0, offset);

    if (this.props.agreement.type === 'workforhire') {
      if (this.refAgreementTextHire) {
        if (
          findDOMNode(this.refAgreementTextHire).getElementsByClassName(
            blockName.replace(/\s/g, '')
          )[0]
        ) {
          offset =
            findDOMNode(this.refAgreementTextHire)
              .getElementsByClassName(blockName.replace(/\s/g, ''))[0]
              .getBoundingClientRect().top -
            findDOMNode(this.refAgreementTextPreview).getBoundingClientRect()
              .top -
            100;
        }
      }
    } else if (this.props.agreement.type === 'producer') {
      if (this.refAgreementTextProducer) {
        if (
          findDOMNode(this.refAgreementTextProducer).getElementsByClassName(
            blockName.replace(/\s/g, '')
          )[0]
        ) {
          offset =
            findDOMNode(this.refAgreementTextProducer)
              .getElementsByClassName(blockName.replace(/\s/g, ''))[0]
              .getBoundingClientRect().top -
            findDOMNode(this.refAgreementTextPreview).getBoundingClientRect()
              .top -
            100;
        }
      }
    } else {
      if (this.refAgreementTextPremiumSplit) {
        if (
          findDOMNode(this.refAgreementTextPremiumSplit).getElementsByClassName(
            blockName.replace(/\s/g, '')
          )[0]
        ) {
          offset =
            findDOMNode(this.refAgreementTextPremiumSplit)
              .getElementsByClassName(blockName.replace(/\s/g, ''))[0]
              .getBoundingClientRect().top -
            findDOMNode(this.refAgreementTextPreview).getBoundingClientRect()
              .top -
            100;
        }
      }
    }
    this.refAgreementTextPreview.scrollTo(0, offset);
  };

  handleSelect(index) {
    let { blocks, tabs, tabCount, start } = this.state;

    if (tabs[index] === '>' && index === tabs.length - 1) {
      const newTabs = ['<'].concat(
        blocks.slice(start + tabCount, start + tabCount + tabCount)
      );

      if (start + tabCount + tabCount < blocks.length) {
        newTabs.push('>');
      }

      this.setState(
        {
          tabs: newTabs,
          tabIndex: 1,
          start: start + tabCount,
          tabName: newTabs[1].name,
        },
        () => {
          this.scrollToRef(newTabs[1].name);
        }
      );
    } else if (tabs[index] === '<' && index === 0) {
      const newStart = start - tabCount;
      let newTabs = blocks.slice(newStart, newStart + tabCount);
      let newTabIndex = tabCount - 1;

      if (newStart > 0) {
        newTabs = ['<'].concat(newTabs);
        newTabIndex++;
      }
      newTabs.push('>');

      this.setState(
        {
          tabs: newTabs,
          tabIndex: newTabIndex,
          start: newStart,
          tabName: newTabs[newTabIndex].name,
        },
        () => {
          this.scrollToRef(newTabs[newTabIndex].name);
        }
      );
    } else {
      this.setState({ tabIndex: index, tabName: tabs[index].name }, () => {
        this.scrollToRef(tabs[index].name);
      });
    }
  }

  getBlockIndex(tab) {
    const { blocks } = this.state;

    return R.findIndex(R.propEq('id', tab.id))(blocks);
  }

  renderCreateWorkOwnership(withPublishers) {
    const {
      workOwnerships,
      agreement,
      ownershipTypes,
      contractBlocks,
      members,
      fields,
    } = this.props;
    let licenserIds = agreement.licenser_ids || [];
    const block = R.find(R.propEq('name', 'Licensing Permissions'))(
      contractBlocks
    );

    if (block && block.options) {
      licenserIds = block.options.licenserIds || [];
    }

    if (workOwnerships && workOwnerships.length) {
      let i = 0;
      const rows = [];
      workOwnerships.forEach(({ user, ownership_type, percentage }) => {
        let userName = '';
        const member = getMemberByUserId(user, members);

        if (member && member.user_info) {
          userName = member.user_info.name;

          if (
            member.user_info.use_company_name &&
            member.user_info.company_name
          ) {
            userName += ` (${member.user_info.company_name})`;
          }
        }

        let publishers = [];
        if (withPublishers) {
          const memberPublisher = R.find(R.propEq('user', user))(
            fields.memberPublishers || []
          );
          publishers =
            memberPublisher && memberPublisher.publishers
              ? memberPublisher.publishers
              : [];
        }

        const ownershipType = getOwnershipTypeName(
          ownership_type,
          ownershipTypes
        );

        let contributorData = '';
        if (fields.soundRecordingType === 'revenue') {
          contributorData =
            ownershipType === 'No Ownership'
              ? 'No Ownership'
              : `${percentage}% revenue from the ${ownershipType}`;
        } else {
          contributorData =
            ownershipType === 'No Ownership'
              ? 'No Ownership'
              : `${percentage}% ownership of the ${ownershipType}`;
        }

        const permissionToLicense =
          agreement.type === 'premium'
            ? licenserIds.indexOf(user) !== -1
              ? 'Yes'
              : 'No'
            : null;

        rows.push(
          <li key={i}>
            <div>
              <span className="text-blue">{userName}: </span>
              <span>{contributorData}</span>
            </div>
            {publishers.map(
              ({ publisherName, society, publisher_share }, index) => (
                <div key={index}>
                  {index === 0 && <span>Publisher Share: </span>}
                  <span
                    className={`text-blue ${
                      index !== 0 && 'duplicate-publisher'
                    }`}
                  >
                    {`${
                      parseFloat(publisher_share, 10) || 0
                    }% ${publisherName} (${society})`}
                  </span>
                </div>
              )
            )}
            {agreement.type !== 'split' && (
              <div>
                <span>Permission to License: </span>
                <span className="text-blue">{permissionToLicense}</span>
              </div>
            )}
          </li>
        );

        i++;
      });

      return <ul>{rows}</ul>;
    }
  }

  renderCreateWork() {
    const { fields, workTypes } = this.props;

    let workTypeName = '';
    let withPublishers = false;

    if (fields.type) {
      workTypeName = getWorkTypeNameById(fields.type, workTypes);
      withPublishers = workTypeName === 'Music';
    }

    return (
      <div className="work-not-accepted">
        {this.renderCreateWorkOwnership(withPublishers)}
      </div>
    );
  }

  renderTermsSummary() {
    const { agreement, contractBlocks } = this.props;

    if (agreement && agreement.type === 'split') {
      return null;
    } else if (contractBlocks) {
      const blocks = [];
      contractBlocks.forEach((block) => {
        if (
          (agreement.type === 'premium' &&
            block['block_type'].includes('premium') === true) ||
          (agreement.type === 'workforhire' &&
            block['block_type'].includes('work_for_hire') === true) ||
          (agreement.type === 'producer' &&
            block['block_type'].includes('producer') === true)
        ) {
          const index = R.findIndex(R.propEq('id', block.id))(contractBlocks);
          if (index !== -1) {
            block.content = contractBlocks[index].content;
            block.options = contractBlocks[index].options;
          }
          blocks.push(block);
        }
      });

      const blockSelected = this.state.tabName === 'Licensing Permissions';

      return (
        <div className="terms-summary">
          <div className="subheading">Terms summary</div>
          <p className="text-gray">
            These are the current terms that your collaborator has proposed.
            Only changes made by the creator of the agreement will be displayed
            here.
          </p>
          <p className="text-gray f-12 text-italic">
            Note: If an attorney has redlined this agreement, the terms below
            may have changed and may not be applicable. Carefully read and
            review your entire agreement before proceeding.
          </p>

          {(agreement.type === 'premium' || agreement.type === 'split') && (
            <hr />
          )}
          {(agreement.type === 'premium' || agreement.type === 'split') && (
            <div
              className={`ownership-work ${blockSelected && 'block-selected'}`}
            >
              {this.renderCreateWork()}
            </div>
          )}

          {agreement.type !== 'premium' && agreement.type !== 'split' && <br />}

          {blocks.map((block, i) => {
            if (block.name !== 'Licensing Permissions') {
              return (
                <ShortContentLess
                  key={i}
                  ref={(c) => (this[`ref${block.name.replace(/\s/g, '')}`] = c)}
                  block={block}
                  tabName={this.state.tabName}
                  blocks={blocks}
                />
              );
            }

            return null;
          })}
        </div>
      );
    }

    return null;
  }

  renderAgreementText() {
    const { agreement } = this.props;

    return agreement.type === 'workforhire' ? (
      <AgreementTextWorkForHire
        ref={(c) => (this.refAgreementTextHire = c)}
        type="create"
        tabName={this.state.tabName.replace(/\s/g, '')}
      />
    ) : agreement.type === 'producer' ? (
      <AgreementTextProducer
        ref={(c) => (this.refAgreementTextProducer = c)}
        type="create"
        tabName={this.state.tabName.replace(/\s/g, '')}
      />
    ) : (
      <AgreementTextPremiumSplit
        ref={(c) => (this.refAgreementTextPremiumSplit = c)}
        type="create"
        tabName={this.state.tabName.replace(/\s/g, '')}
      />
    );
  }

  handlePreviewItem = (e, index) => {
    e.preventDefault();

    if (index === 1) {
      window.scrollTo(0, window.innerHeight);
    } else {
      this.setState({ previewIndex: index }, () => {
        this.scrollToRef(this.state.tabName);
      });
    }
  };

  renderPreviewWindow() {
    const { previewIndex } = this.state;
    const previewIcon = [
      [IconAlert, IconAlertGray, 'Terms summary.'],
      [
        IconSummary,
        IconSummaryGray,
        'Preview the entire agreement and see how your suggestions could change the entire agreement text.',
      ],
    ];

    return (
      <div className="preview-window">
        <div className="preview-header create-view">
          {previewIcon.map((item, index) => {
            return (
              <div
                key={index}
                className={`preview-item ${
                  index === previewIndex && 'preview-item-selected'
                }`}
                onClick={(e) => this.handlePreviewItem(e, index)}
              >
                <OverlayTrigger
                  overlay={<Tooltip id="tooltip-split">{item[2]}</Tooltip>}
                  placement="top"
                >
                  <div>
                    <img
                      src={index === previewIndex ? item[0] : item[1]}
                      alt={index}
                    />
                    <div className="echo-animation" />
                  </div>
                </OverlayTrigger>
              </div>
            );
          })}
        </div>
        <div ref={(c) => (this.refPreview = c)} className="preview-body">
          {previewIndex === 0 && this.renderTermsSummary()}
        </div>
      </div>
    );
  }

  handleTab(direction) {
    let { tabIndex } = this.state;

    if (direction === 'back') tabIndex--;
    else tabIndex++;

    this.handleSelect(tabIndex);
    window.scrollTo(0, 0);
  }

  collapsePreview = (e) => {
    e.preventDefault();
    this.setState((state) => ({
      isCollapsPreview: !state.isCollapsPreview,
    }));
  };

  getBlockChecked(tab) {
    const { contractBlocks } = this.props;

    const ownershipBlock = R.find(R.propEq('name', 'Ownership'))(
      contractBlocks
    );
    if (tab.name === 'Payments') {
      if (ownershipBlock.checked && ownershipBlock.options.composition === 1) {
        if (tab.checked && tab.options.statutoryPercentage === '') {
          return false;
        }
      }
    }
    return tab.checked;
  }

  renderTabs() {
    const { agreement } = this.props;
    const { blocks, tabs, isCollapsPreview } = this.state;

    if (blocks.length) {
      return (
        <Tabs
          selectedIndex={this.state.tabIndex}
          onSelect={(tabIndex) => this.handleSelect(tabIndex)}
        >
          <TabList>
            {tabs.map((tab, i) => {
              if (tab === '<' || tab === '>') {
                return (
                  <Tab key={i} style={{ padding: '6px 12px' }}>
                    {tab}
                  </Tab>
                );
              } else {
                const checked = this.getBlockChecked(tab);

                return (
                  <Tab key={i} style={{ width: this.tabWidth }}>
                    {tab.name}
                    {checked ? <FontAwesome name="check" /> : null}
                  </Tab>
                );
              }
            })}
          </TabList>

          {tabs.map((tab, i) => {
            const blockIndex = this.getBlockIndex(tab);

            if (tab === '<' || tab === '>') {
              return <TabPanel key={i} />;
            } else {
              return (
                <TabPanel key={i}>
                  <div>
                    <div className="tab-container">
                      <div className="content-panel">
                        <ContractBlock block={tab} {...tab.options}>
                          <div className="nav">
                            {blockIndex > 0 ? (
                              <button
                                onClick={(e) => this.handleTab('back')}
                                className="button-back"
                              >
                                Back
                              </button>
                            ) : null}
                            {blockIndex < blocks.length - 1 ? (
                              <button
                                onClick={(e) => this.handleTab('next')}
                                className="button-continue"
                              >
                                Continue
                              </button>
                            ) : (
                              <button
                                onClick={(e) => this.handleNext()}
                                className="button-continue"
                              >
                                Review and send
                              </button>
                            )}
                          </div>
                        </ContractBlock>
                        <br />
                        <a
                          href="https://cosynd.zendesk.com/hc/en-us/categories/115002431827-How-To-Guides"
                          target="_blank"
                        >
                          Need more help? Click here to visit our knowledge
                          base.
                        </a>
                        <br />
                      </div>

                      {agreement && !agreement.archived && (
                        <div className="show-icon">
                          {isCollapsPreview ? (
                            <AnimationArrow
                              classNames="arrow-animation arrow-right"
                              onClick={this.collapsePreview}
                            />
                          ) : (
                            <AnimationArrow
                              classNames="arrow-animation arrow-left"
                              onClick={this.collapsePreview}
                            />
                          )}
                        </div>
                      )}

                      <div
                        className={`preview-panel ${
                          isCollapsPreview && 'preview-collapse-panel'
                        }`}
                      >
                        {this.renderPreviewWindow()}
                      </div>
                    </div>

                    <br />
                    <h3 className="text-center">Preview your Agreement</h3>
                    <div
                      className="preview-body"
                      ref={(c) => (this.refAgreementTextPreview = c)}
                    >
                      {this.renderAgreementText()}
                    </div>
                  </div>
                </TabPanel>
              );
            }
          })}
        </Tabs>
      );
    }
  }

  handlePrev() {
    const { params } = this.props;

    if (params.prev === 'ownership') {
      if (params.type === 'premium-split') {
        this.props.router.push(
          '/create/agreement-ownership-percentage/premium-split'
        );
      } else {
        this.props.router.push('/create/agreement-ownership-percentage/split');
      }
    } else if (params.prev === 'producer') {
      this.props.router.push('/create/agreement-producer');
    } else if (params.prev === 'work-for-hire') {
      this.props.router.push('/create/agreement-work-for-hire');
    } else {
      this.props.router.goBack();
    }
  }

  render() {
    const { team, agreement, fields } = this.props;

    if (!team || !agreement) {
      return null;
    } else {
      return (
        <div className="agreement-terms">
          <div className="detail-view">
            <Heading text="Agreement Details" />

            {this.state.blocks.length > 0 && (
              <p className="text-gray">
                To finish creating your agreement, you will need to answer a few
                questions for us. Your answers will be used to build the terms
                of the agreement that will be proposed to your collaborators.
                You can view how your choices will change the language of the
                agreement by scrolling down to the agreement preview. Start with
                the first tab of questions and click "continue" to move to the
                next.
              </p>
            )}

            <div ref="tabsContainer" className="content">
              <Sidebar fields={fields} agreement={this.props.agreement} />
              {this.renderTabs()}
            </div>
            <div className="step-nav">
              <NavButtons direction="back" prev={() => this.handlePrev()} />
              <NavButtons direction="next" next={() => this.handleNext()} />
            </div>
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  fields: state.create.fields,
  ownershipTypes: state.global.ownershipTypes,
  contractBlocks: state.global.contractBlocks,
  workTypes: state.global.workTypes,
  agreementContractBlocks: state.agreements.contractBlocks,
  agreement: state.agreements.selectedAgreement,
  team: state.teams.selectedTeam,
  members: state.users.members,
  workOwnerships: state.workOwnerships.workOwnerships,
  status: state.agreements.status,
  error: state.agreements.error,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
  loadBlockContents: (agreementId) => {
    dispatch(actions.getAgreementContractBlockContents(agreementId));
  },
  saveContractBlocks: (blocks) => {
    dispatch(actions.saveAgreementContractBlocks(blocks));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AgreementTerms);



// WEBPACK FOOTER //
// src/components/Agreements/AgreementTerms.jsx